import { render, staticRenderFns } from "./limitsMain.vue?vue&type=template&id=5181f604&"
import script from "./limitsMain.vue?vue&type=script&lang=js&"
export * from "./limitsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports